module.exports = {
	"discount-sticker": "findify-components--cards--product--stickers__discount-sticker",
	"discountSticker": "findify-components--cards--product--stickers__discount-sticker",
	"outOfStockSticker": "findify-components--cards--product--stickers__outOfStockSticker",
	"out-of-stock-sticker": "findify-components--cards--product--stickers__out-of-stock-sticker",
	"outOfStockSticker": "findify-components--cards--product--stickers__out-of-stock-sticker"
};